import { render } from "./footerpage.vue?vue&type=template&id=2b657b33&scoped=true"
import script from "./footerpage.vue?vue&type=script&lang=js"
export * from "./footerpage.vue?vue&type=script&lang=js"

import "./footerpage.vue?vue&type=style&index=0&id=2b657b33&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b657b33"]])

export default __exports__